import ApiService from '@/services/api.service';

const ClaimList = {
    getAll(parameter) {
        var params = {
            SearchCriteria: parameter.SearchCriteria,
            PageSize: parameter.PageSize,
            PageNumber: parameter.PageNumber,
            DateFrom: parameter.DateFrom,
            DateTo: parameter.DateTo,
            PatientCode: parameter.PatientCode,
            PatientCodeList: parameter.PatientCodeList,
            StatusList: parameter.StatusList,
            InsurancesList: parameter.InsurancesList,
            PaymentsList: parameter.PaymentsList
        };

        return ApiService.getWithArray('/PatientClaims', params);
    },

    getClaim(Id) {
        return ApiService.get(`/PatientClaims/${Id}`);
    },

    getHistory(SeqNo) {
        const requestData = {
            method: 'get',
            url: '/PatientClaims/History',
            params: {
                SeqNo: SeqNo
            }
        };
        return ApiService.customRequest(requestData);
    },

    getDetail(SeqNoList) {
        var parameter = {
            SeqNoList: SeqNoList
        };
        return ApiService.getWithArray('/PatientClaims/Detail', parameter);
    },

    GetClaimPayments(PatientCode, IssLineRequest) {
        return ApiService.post(`/PatientClaims/ClaimPayment/${PatientCode}`, IssLineRequest);
    },

    VoidClaim(data) {
        return ApiService.put(`/PatientClaims/Void`, data);
    },

    UpdateFlag(data) {
        return ApiService.put(`/PatientClaims/Flags`, data);
    },

    Add(data) {
        return ApiService.post(`/PatientClaims`, data);
    },

    UndoAttendance(data) {
        return ApiService.post(`/PatientClaims/UndoAttendance`, data);
    },

    Update(id, data) {
        return ApiService.put(`/PatientClaims/${id}`, data);
    },

    ChargesByDateRange(PatientCode, DateFrom, DateTo, IsHideVoid, IsHideZeroBal) {
        let url = `PatientClaims/ChargesByDateRange/?PatientCode=${PatientCode}&IsHideVoid=${IsHideVoid}&IsHideZeroBal=${IsHideZeroBal}`;
        if (DateFrom) url += `&DateFrom=${DateFrom}`;
        if (DateTo) url += `&DateTo=${DateTo}`;
        return ApiService.get(url);
    },

    PaymentsByDateRange(PatientCode, DateFrom, DateTo, IsHideVoid, IsHideZeroBal) {
        let url = `PatientClaims/PaymentsByDateRange/?PatientCode=${PatientCode}&IsHideVoid=${IsHideVoid}&IsHideZeroBal=${IsHideZeroBal}`;
        if (DateFrom) url += `&DateFrom=${DateFrom}`;
        if (DateTo) url += `&DateTo=${DateTo}`;
        return ApiService.get(url);
    },

    TotalCredit(PatientCode) {
        return ApiService.get(`/PatientClaims/TotalCredit/?PatientCode=${PatientCode}`);
    },

    filter() {
        return ApiService.get('ClaimStatuses/filter');
    },

    listing(parameter) {
        return ApiService.getWithArray('ClaimStatuses', parameter);
    },

    totalListing(parameter) {
        return ApiService.getWithArray('ClaimStatuses/total', parameter);
    },
    checkStatus(ClaimId, BatchNo) {
        return ApiService.get(`ClaimBatches/status/${ClaimId}:${BatchNo}`);
    },
    validate(parameter) {
        return ApiService.getWithArray('ClaimBatches/validation', parameter);
    },
    checkError(parameter) {
        return ApiService.get(`ClaimBatchValidationError/${parameter.clMUID}`);
    },
    getBatchNo() {
        return ApiService.get('/ClaimStatuses/BatchNo');
    },
    getCheckNo() {
        return ApiService.get('/ClaimStatuses/CheckNo');
    },
    getStatus() {
        return ApiService.get('/ClaimStatuses/Status');
    },
    getInsurances() {
        return ApiService.get('/Insurances');
    },
    getProviders() {
        return ApiService.get('/Doctors');
    },
    ValidateAndGetStatus(BatchId) {
        return ApiService.get(`/ClaimBatches/validation/?BatchId=${BatchId}`);
    },

    getClaimError(CLMUID) {
        return ApiService.get(`/ClaimBatchValidationError/${CLMUID}`);
    },

    GetVisitDiagnosisCodes(PatientCode) {
        //&ServiceDate=${ServiceDate}
        return ApiService.get(
            `/DiagnosisICD10Providers/VisitDiagnosisCodes?PatientCode=${PatientCode}`
        );
    },

    toggleShowInPatientPortal(data) {
        return ApiService.put(`/PatientClaims/ToggleShowInPatientPortal`, data);
    }
};

export default ClaimList;
